// extracted by mini-css-extract-plugin
module.exports = {"container":"categories_container__T4l4C","controls":"categories_controls__iUCRD"};